(()=>{
  if(window.__JovelaPricingLoaded)return;
  const node=document.getElementById('JovelaDiscountConfig');
  if(!node)return;
  window.__JovelaPricingLoaded=true;
  let config;
  try{config=JSON.parse(node.textContent)}catch(e){return}
  const format=cents=>new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format(Math.round(Number(cents||0)/100));
  const applicable=(id,quantity)=>{
    if(!config.enabled)return null;
    const candidates=config.offers.filter(o=>o.enabled&&Number(o.quantity)<=Number(quantity)&&Number(o.percent)>0&&(o.scope==='all'||(o.products||[]).map(String).includes(String(id))));
    candidates.sort((a,b)=>Number(b.quantity)-Number(a.quantity));
    const highest=Number(candidates[0]?.quantity||0);
    return candidates.find(o=>Number(o.quantity)===highest&&o.scope==='selected')||candidates[0]||null;
  };
  const offers=id=>{
    if(!config.enabled)return [];
    const quantities=[...new Set(config.offers.filter(o=>o.enabled&&Number(o.percent)>0&&(o.scope==='all'||(o.products||[]).map(String).includes(String(id)))).map(o=>Number(o.quantity)))];
    return quantities.map(quantity=>applicable(id,quantity)).filter(Boolean).sort((a,b)=>a.quantity-b.quantity);
  };
  const calculate=(price,id,quantity=1)=>{
    const regular=Math.round(Number(price||0)*Number(quantity));
    const rule=applicable(id,quantity);
    const percent=rule?Number(rule.percent):0;
    const final=Math.round(regular*(100-percent)/10000)*100;
    return {regular,final,saving:regular-final,percent,rule,quantity:Number(quantity)};
  };
  const label=rule=>rule?.label?rule.label.replace(/\{discount\}/g,String(rule.percent))+(rule.best?' · MEJOR OFERTA':''):`AHORRA ${rule?.percent||0}%${rule?.best?' · MEJOR OFERTA':''}`;
  const render=(el,value)=>{
    const native=el.closest('.price');
    if(native){native.classList.remove('price--on-sale','volume-pricing--sale-badge');native.classList.toggle('jovela-controlled',Boolean(value.percent));el.hidden=!value.percent;if(!value.percent)return}
    const final=el.querySelector('[data-jovela-final]'),old=el.querySelector('[data-jovela-regular]'),badge=el.querySelector('[data-jovela-badge]');
    if(final)final.textContent=format(value.final);
    if(old){old.textContent=format(value.regular);old.hidden=!value.percent}
    if(badge){badge.textContent=value.percent?`-${value.percent}%`:'';badge.hidden=!value.percent}
  };
  const cards=(scope=document)=>scope.querySelectorAll('[data-jovela-card-price]').forEach(el=>render(el,calculate(el.dataset.price,el.dataset.productId)));
  window.JovelaPricing={calculate,offers,label,format,render,cards};
  const init=()=>{
    cards();
    new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(added=>{
      if(added.nodeType!==1)return;
      if(added.matches?.('[data-jovela-card-price]'))render(added,calculate(added.dataset.price,added.dataset.productId));
      cards(added);
    }))).observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',()=>{
    const latest=document.getElementById('JovelaDiscountConfig');
    if(latest){try{config=JSON.parse(latest.textContent)}catch(e){return}}
    cards(document);
    document.dispatchEvent(new Event('jovela:discounts-changed'));
  });
})();
